import { DATATABLE_COLUMNS } from '../actions/datatable'
import { SETTINGS_GET } from '../actions/settings'

const actions = {
  getDatatableSettings ({ commit }, model) {
    return new Promise((resolve, reject) => {
      this.dispatch(SETTINGS_GET, { settingsKey: 'datatable_' + model })
        .then(response => {
          // user settings exist, push to state
          this.commit('setDatatableSettings', {
            'key': model,
            'settings': {
              'perPage': response.data.perPage,
              'columns': response.data.columns
            }
          })
          resolve(response)
        }).catch(err => {
          reject(err)
        })
    })
  },
  getDefaultDatatableSettings ({ commit }, model) {
    return new Promise((resolve, reject) => {
      this.dispatch(DATATABLE_COLUMNS, { model })
        .then(response => {
          let userColumns = {}
          let columns = response.data
          columns.forEach(function (row, index) {
            let isEnabled = false
            if (row.default === true) {
              isEnabled = true
            }

            userColumns[row.src] = isEnabled
          })

          this.commit('setDatatableSettings', {
            'key': model,
            'settings': {
              'perPage': 15,
              'columns': userColumns
            }
          })

          resolve(userColumns)
        }).catch(err => {
          reject(err)
        })
    })
  }
}

export default {
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/datatableSettings.js